module.exports = __webpack_public_path__ + "img/northmacedonia.1b922c4f.svg";